export type EmailStatusFilter = 'sent' | 'not-sent' | undefined

export type EmailFilter = {
  sent: boolean
  notSent: boolean
}

export const toEmailFilter = (emailStatus: EmailStatusFilter): EmailFilter => {
  if (emailStatus === 'sent') {
    return { sent: true, notSent: false }
  }
  if (emailStatus === 'not-sent') {
    return { sent: false, notSent: true }
  }
  return { sent: true, notSent: true }
}
